import { TResetPasswordReq } from "@sharedTypes/req.type";
import { TResetPasswordRes } from "@sharedTypes/res.type";

import missingParametersError from "api/Error";
import axios from "axios";

export async function ResetPassword(token: string, email: string, password: string, otp: string) {
  const apiUrl = "/auth/resetpassword";

  const body: TResetPasswordReq = {
    token,
    email,
    password,
    otp,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TResetPasswordRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
